//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// responsive
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// 모달
import BasicBtn from "../../../component/button/BasicBtn";

export default function SignComplete() {
    return (
        <Container>
            <CompleteSection>
                <MainText>WELCOME!</MainText>
                <SubText>fabWeaver의 회원이 되신걸 환영합니다!</SubText>

                <CompleteBtn>
                    {/* 프리오더때는 하나뿐인 그 제품으로 연결..부탁드립니다 */}
                    <CompleteLink to={"/product/detail/1"}>
                        <BasicBtn text="쇼핑하러가기" bgWhite={true} />
                    </CompleteLink>
                </CompleteBtn>
            </CompleteSection>
        </Container>
    );
}

const Container = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
    }
`;
const CompleteSection = styled.div`
    width: calc(100vw * (248 / 1920));
    margin: calc(100vw * (355 / 1920)) auto;

    text-align: center;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (248 / 1300));
        margin: calc(100vw * (355 / 1300)) auto;
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin: ${M(306)} auto;
    }
`;
const MainText = styled.p`
    font-family: "Pop-EL";
    font-size: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(30)};
    }
`;
const SubText = styled.p`
    font-family: "Noto-R";
    margin: calc(100vw * (20 / 1920)) 0 calc(100vw * (60 / 1920));

    font-size: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (20 / 1300)) 0 calc(100vw * (60 / 1300));

        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(10)} 0 ${M(25)};

        font-size: ${M(14)};
    }
`;
const CompleteLink = styled(Link)``;
const CompleteBtn = styled.div`
    width: calc(100vw * (200 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (200 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(180)};
    }
`;
